import styled from 'styled-components';

/**
 * MenuNavButton
 *
 * Buttons sitting on the left and right of the MenuBlock, control the left and right scroll if the menu overflows
 */
export const MenuNavButton = styled.button<{ left?: boolean }>(
    ({ theme, left = true }) => `
    appearance: none;
    background: linear-gradient(to ${left ? `right` : `left`}, ${
        theme.sections.header.background
    } 1.5rem, rgba(255, 255, 255, 0));
    border: none;
    bottom: 0;
    color: ${theme.sections.header.a};
    cursor: pointer;
    font-size: var(--font-size-a);
    padding-${left ? `right` : `left`}: 2.5rem;
    position: absolute;
    top: 0;

    ${left ? `left: 0` : `right: 0`};

    /* Specific styling for Safari */
    /* Calculation of linear-gradients is different in safari causing a visual bug */
    /* In this case we remove the gradient */
    @media not all and (min-resolution:.001dpcm) {
        @supports (-webkit-appearance:none) {
            background: ${theme.sections.header.background};
            padding-${left ? `right` : `left`}: .5rem;
        }
    }
`,
);

/* ----------------------------- StyledMenuBlock ----------------------------- */

/**
 * StyledMenuBlock
 *
 * Root component for the MenuBlock containing all other elements
 */
export const StyledMenuBlock = styled.div(
    ({ theme }) => `
    flex: 1;
    overflow: hidden;
    padding: 0 1rem;
    position: relative;
    white-space: nowrap;

    @media screen and (max-width: 1080px) {
        margin: 0 -1.5rem;
        padding: 0 var(--page-element-x-padding) 1rem;
        flex-basis: 100%;
        order: 4;
        background: ${theme.sections.menu.background};

        ${MenuNavButton} {
            display: none;
        }
    }
`,
);

/**
 * MenuBlockWrapper
 *
 * Holds the menu items, handles the overflow and scrolling if there are too many items
 */
export const MenuBlockWrapper = styled.div`
    display: flex;
    gap: 1.5rem;
    overflow-x: auto;
    line-height: 1.5;

    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    /* Hide scrollbar for Chrome, Safari and Opera */
    &::-webkit-scrollbar {
        display: none;
    }
`;
